/**
 * Vanilla Next (vn) API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const OrderBy = {
    id: 'id',
    number: 'number',
    date: 'date'
} as const;
export type OrderBy = typeof OrderBy[keyof typeof OrderBy];

